import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../auth.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';

@Component({
  selector: 'ngx-validate-email',
  templateUrl: './validate-email.component.html',
  styleUrls: ['./validate-email.component.scss'],
})
export class ValidateEmailComponent implements OnInit {

  loading = false;
  timeoutSeconds = 5;
  error = false;
  success = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      await this.validateEmail(params.email, params.token);
    });
  }


  async validateEmail(email: string, token: string) {
    this.loading = true;
    const [err, response]: any = await this.authService.validateEmail(email, token);
    this.loading = false;
    this.timer();
    if (err) {
      this.error = true;
      return console.error(err.status);
    }
    this.success = true;
    console.error(response);
  }

  timer () {
    setInterval(() => {
      if (this.timeoutSeconds <= 0) return this.redirect();
      this.timeoutSeconds -= 1;
    }, 1000);
  }

  redirect () {
    return;
    return this.router.navigate(['auth/login']);
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
